import {useDispatch} from 'react-redux'
import {
	removeLeaderboardRecord,
	editLeaderboardRecord,
	addLeaderboardRecord,
	setMetricCreator,
	setShow
} from './slice'
import {capitalize} from '../../util/util'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'
import {useSquatLeaderboard} from './hooks'

const LeaderboardRecord = ({record,position})=>{
	const dispatch = useDispatch()

	const keys = [
		'depth_score',
		'trunk_collapse_score',
		'hip_shift_score',
		'knee_symmetry_score',
		'left_valgus_score',
		'right_valgus_score',
		'average'
	]

	const handleRemove = ()=>{
		if(!window.confirm(`Remove ${record.name}'s record?`)) return 
		dispatch(removeLeaderboardRecord(record.id))
	}

	const handleEditName = (e)=>{
		dispatch(editLeaderboardRecord({
			id:record.id,
			update:{name:e.target.value}
		}))
	}

	return (
		<tr>
			<td>({position})</td>
			<td>
				<strong>
					<Form.Control 
						defaultValue={capitalize(record.name)} 
						onBlur={handleEditName}
						size="sm"
					/>
				</strong>
			</td>
			{keys.map(k=>(
				<td style={{
					textAlign:k==='average'?'right':'center',
					fontWeight:k==='average'?'600':'400'
				}}>
					{Math.floor(record[k])}
				</td>
			))}
			<td style={{textAlign:'right'}}>
				<Button 
					onClick={()=>{
						handleRemove(record)
					}}
					variant="outline-danger"
					size="sm"
				>
					X
				</Button>
			</td>
		</tr>
	)
}

const Leaderboard = ()=>{
	const {status,records} = useSquatLeaderboard()
	return (
		<div className="mt-3">
			<div className="text-center">
				<strong>Leaderboard</strong>
			</div>
			<div className="text-center text-info">
				Best: {Math.max(...records.map(r=>r.average)).toFixed(2)}
			</div>
			<Table className="mt-2" size="sm">
				<thead>
					<tr>
						<th/>
						<th>Name</th>
						<th style={{textAlign:'center'}}>Depth</th>
						<th style={{textAlign:'center'}}>Trunk-Shin Angle</th>
						<th style={{textAlign:'center'}}>Hip Shift</th>
						<th style={{textAlign:'center'}}>Knee Movement Symmetry</th>
						<th style={{textAlign:'center'}}>L Knee</th>
						<th style={{textAlign:'center'}}>R Knee</th>
						<th style={{textAlign:'right'}}>Avg</th>
						<th/>
					</tr>
				</thead>
				<tbody>
					{records.sort((a,b)=>b.average-a.average).map((record,i)=>(
						<LeaderboardRecord key={record.id} record={record} position={i+1}/>
					))}
				</tbody>
			</Table>
		</div>
	)
}

export default Leaderboard